import React from 'react'
import Navbar from '../components/Sidebar'
import Header from '../components/HeaderCar'
import { Link } from "react-router-dom"

const Drainageimg = 'https://fnicdn.blob.core.windows.net/regionh/stock/lillypads.jpg';

export default function Downloads() {
    return (
        <div>

            <main role="main" className="flex-shrink-0 min-vh-100">
                <div className='container'>
                    <div className='row ps-lg-4'>
                        <h3>Downloads</h3>
                        <div className='col-lg-8'>
                            <p>
                                Region H is one of 16 state water supply planning regions defined by the Texas Water Development Board (TWDB).
                                The regional water plans prepared by each Regional Water Planning Group (RWPG) will be combined into a comprehensive state water plan.
                                The planning effort is part of a consensus-based planning effort to include local concerns in the statewide planning effort.
                            </p>
                            <ul className='ms-3'>
                                <li><Link to="/PlanningDocs">Planning Documents</Link></li>
                                <li><a href="https://fnicdn.blob.core.windows.net/regionh/documents/RHWPG_Blyaws_202205.pdf" rel="noreferrer" target="_blank">Bylaws</a></li>
                            </ul>
                        </div>
                        <div className='col-lg-4 mb-3'>
                            <div className="card" style={{ backgroundColor: "#f2f2f2" }} >
                                <img src={Drainageimg} className="card-img-top p-2" />
                            </div>
                        </div>

                    </div>
                </div>
            </main>

        </div>
    )
}
